import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../PrimereactComponents';
import { useFormatters } from '../../../utils/texts';
import './MeetingAttendanceBar.css';

type Props = {
    id: string;
    percent: number;
    present?: number;
    total?: number;
    color: string;
    gender: 0 | 1;
};

const MeetingAttendanceBar = ({ id, percent, present, total, color, gender }: Props) => {
    const { t, i18n } = useTranslation(['parties', 'translation']);
    const formatter = useFormatters(i18n.language);

    const hasCounts = present != null && total != null;
    const hasRecords = !hasCounts || total > 0;
    const percentText = formatter.percent2From100(percent);
    const targetId = `meeting-attendance-${id}`;

    const value = !hasRecords
        ? '—'
        : hasCounts
          ? t('x-outOf-y', { ns: 'translation', x: present, y: total })
          : percentText;
    const tooltip = !hasRecords
        ? t('PartyDetail.meetingAttendanceNoRecords')
        : hasCounts
          ? t('PartyDetail.meetingAttendanceTooltip', {
                context: gender === 1 ? 'female' : 'male',
                present,
                total,
                count: total,
                percent: percentText
            })
          : percentText;

    return (
        <>
            <div id={targetId} className='meeting-attendance' style={{ '--attendance-color': color } as CSSProperties}>
                <div className='meeting-attendance-caption'>
                    <span className='material-symbols-rounded'>event_available</span>
                    <span className='meeting-attendance-label'>{t('PartyDetail.atMeetings')}</span>
                    <span className='meeting-attendance-value'>{value}</span>
                </div>
                <div className='meeting-attendance-track'>
                    <span style={{ width: `${hasRecords ? percent : 0}%` }} />
                </div>
            </div>
            <Tooltip target={`#${targetId}`} position='top'>
                {tooltip}
            </Tooltip>
        </>
    );
};

export default MeetingAttendanceBar;
